export default __webpack_public_path__ + "static/media/edit_cab.4afe30d0.svg";